import * as request from 'superagent';
import {SuperAgentRequest} from 'superagent';

class HttpService {
    get<T>(url: string): Promise<T> {
        return HttpService.execute(request.get(HttpService.prepareUrl(url)));
    }

    private static prepareUrl(url: string) {
        if (process.env.VUE_APP_API_HOSTNAME) {
            return process.env.VUE_APP_API_HOSTNAME + url;
        }
        return url;
    }

    private static execute<T>(requestBuilder: SuperAgentRequest): Promise<T> {
        return requestBuilder
            .then(response => response.body || response.text);
    }
}

export const http = new HttpService();
